import { Microfrontend } from '@cian/mf-react';
import * as React from 'react';
import { useApplicationContext } from '../../utils/applicationContext';
import { IManifestInfo } from '../../types/manifestInfo';
// oxlint-disable-next-line cian-eslint-compat/no-restricted-paths
import { SEARCH_STRING_MANIFEST_INFO_SETTING_KEY } from '../../../node/services/fetchSearchString';
import { useEffect } from 'react';
import { trackSearchButtonClick, trackSearchOnMapButtonClick } from '../../components/FiltersSearchButtons/tracking';
import { EPageKind } from '../../types/page';
import { FiltersTabsContainer } from '../FiltersTabsContainer';
import { FiltersContainer } from '../FiltersContainer';

import styles from './SearchStringContainer.css';

const SEARCH_UPDATED_EVENT = 'search:updated';

enum ESearchType {
  List = 'list',
  Map = 'map',
}

type TSearchUpdatedEventDetail = {
  url: string;
  type: ESearchType;
};

export const SearchStringContainer: React.FC = () => {
  const { config } = useApplicationContext();
  const manifestInfo = config.get<IManifestInfo | null>(SEARCH_STRING_MANIFEST_INFO_SETTING_KEY);

  useEffect(() => {
    const onSearchUpdated = ({ detail: { type, url } }: CustomEvent<TSearchUpdatedEventDetail>) => {
      if (type === ESearchType.List) {
        trackSearchButtonClick(EPageKind.Default, url);
      } else {
        trackSearchOnMapButtonClick(EPageKind.Default, url);
      }

      window.location.href = url;
    };

    addEventListener(SEARCH_UPDATED_EVENT, onSearchUpdated);

    return () => {
      removeEventListener(SEARCH_UPDATED_EVENT, onSearchUpdated);
    };
  }, []);

  if (!manifestInfo) {
    return (
      <>
        <FiltersTabsContainer />
        <FiltersContainer />
      </>
    );
  }

  return (
    <div className={styles['block-container']}>
      <div className={styles['search-string-block']}>
        <Microfrontend {...manifestInfo} />
      </div>
    </div>
  );
};
